export default __webpack_public_path__ + "static/media/crc-hold-batch.aabb03bc.svg";